import React from 'react';
import Modal from 'react-modal';

interface ExtraServicesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ExtraServicesModal: React.FC<ExtraServicesModalProps> = ({ isOpen, onClose }) => {
  const handleContactSupport = () => {
    window.location.href = 'mailto:info@kitkeeper.co.uk?subject=Extra Services Request';
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content extra-services-modal"
      overlayClassName="modal-overlay"
      ariaHideApp={false}
    >
      <div className="modal-header">
        <h2>Extra Services</h2>
        <button onClick={onClose} className="modal-close-btn">×</button>
      </div>
      
      <div className="modal-body">
        <p className="extra-services-intro">
          Howdy there Mohanad! 👋
        </p>

        <div className="extra-services-list">
          <div className="extra-service-item">
            <h3>Repacking - £20</h3>
          </div>
          
          <div className="extra-service-item">
            <h3>Door-step collection - £45</h3>
          </div>

          <div className="extra-service-placeholder">
            <p>...</p>
          </div>

          <div className="extra-service-placeholder">
            <p>...</p>
          </div>
        </div>

        <button 
          className="submit-btn extra-services-contact-btn"
          onClick={handleContactSupport}
        >
          Book extra service
        </button>
      </div>
    </Modal>
  );
};

